import * as React from 'react';
import { Box } from '@mui/system';
import axios from 'axios';
import { DataTable } from 'mantine-datatable';
import { Fade, Tooltip, Typography } from '@mui/material';


export const DomainsPopular = React.memo(() => {

    const [data, setData] = React.useState("")
    const isMounted = React.useRef(false)

    React.useEffect(() => {
        isMounted.current = true

        return () => {
            isMounted.current = false
        }
    }, [])

    React.useEffect(() => {
        let cancel = false;

        const fetch = async () => {
            if (!cancel) {
                const res = await axios.get("https://router.prajwal5.workers.dev/popular-domains")
                if (isMounted) {
                    setData(res);
                }

            }
        };
        fetch();

        return () => {
            cancel = true;
        }
    }, []);

    if (!data) {
        return <></>
    } else {
        console.log(data.data.rankingEntries.sort((a, b) => (parseInt(a.rank) > parseInt(b.rank)) ? 1 : -1))
        const d = data.data.rankingEntries.map(
            (info) => {

                return (
                    {
                        rank: info.rank,
                        domain: info.domain,
                        Category: info.Category,
                        RankChange: (info.RankChange < 0 ? "▼" : info.RankChange > 0 ? "▲": "-" )
                    }
                )
            }
        )
        return (
            <Box style={{ paddingTop: "4em", marginLeft: "2em", marginRight: "2em" , color:"purple", font_family:""}}>
                <Tooltip
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    title="Popular domains ranked. Arrows show which domains have changed rank in the past 30 days!"
                    arrow
                    placement="top"
                >
                    <Box style={{ marginBottom: "2em" }}>
                        <Typography variant="h4" component="h4">
                            Domain Data
                        </Typography>
                    </Box>
                </Tooltip>
                <DataTable
                    withBorder
                    borderRadius="sm"
                    withColumnBorders
                    striped
                    highlightOnHover
                    records={d}
                    border="1px solid"
                    withBorder
                  withColumnBorders
                  borderColor="teal"
                  rowBorderColor="gray"

                    columns={[
                        {
                            accessor: 'rank',
                            title: 'Rank of Domain',
                            textAlignment: 'center',
                        },
                        {   accessor: 'domain', 
                            textAlignment: 'center',
                            title: 'Internet Domain'
                        },
                        {
                            title: 'Category of Domain',
                            accessor: 'Category',
                            textAlignment: 'center',
                        },
                        {
                            title: 'Rank Change',
                            accessor: "RankChange",
                            textAlignment: "center"

                        }
                    ]}
                />
            </Box>
        );
    }

});